// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"7441399b","921":"243a7868"}[chunkId] + ".chunk.js";
};